__turbopack_context__.v({
  "separator": "CoreSeparator-module-scss-module__oK62zW__separator",
});
